import { TitleAndTextLine } from 'Components/lines/title-and-text-line/TitleAndTextLine';
export default TitleAndTextLine;
